import {
  TextField,
  IconButton,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import MDBox from "components/MDBox";
import Button from "@mui/material/Button";
import { CircularProgress } from "@material-ui/core";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import RefreshIcon from "@material-ui/icons/Refresh";
import FilterBar from "examples/FilterBar/FilterBar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import { setRoleType } from "layouts/events/Redux/actionCreator";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { Link, useLocation } from "react-router-dom";
import { Link, useLocation, useParams } from "react-router-dom";

import { getOrwinCandidatesList } from "./Redux/actionCreator";
import {
  pageChanged,
  pageLimit,
  updateOrwinSearchKey,
  updateOrwinQualification,
  updateOrwinSpecialization,
  updateOrwinDepartment,
} from "./Redux/reducer";
import moment from "moment";
import Tooltip from "@mui/material/Tooltip";

function OrwinCandidates({ dialog, title }) {
  const { state } = useLocation();
  const { id } = useParams();
  // console.log(id, "Id");
  const dispatch = useDispatch();
   const [inputValue, setInputValue] = useState("");
   const [inputQualificationValue, setInputQualificationFilterValue] = useState("");
   const [inputSpecializationFilterValue, setInputSpecializationFilterValue] = useState("");
   const [inputDepartmentFilterValue, setInputDepartmentFilterValue] = useState("");

   const [selectedOption, setSelectedOption] = useState("");
   const [manualValue, setManualValue] = useState("");
   

  function getCandidateId(params) {
    return `${params?.row?._id || "NA"}`;
  }

  function getCandidateCode(params) {
    return `${params?.row?.candidateId || "NA"}`;
  }

  function getFullName(params) {
    return `${params?.row?.fullName || "NA"}`;
  }

  function getEmail(params) {
    return `${params?.row?.address?.email || "NA"}`;
  }

  function getMobileNo(params) {
    return `${params?.row?.client?.mobileNo || "NA"}`;
  }

  function getAlternateEmail(params) {
    return `${params?.row?.alternateEmail || "NA"}`;
  }

  function getDateOfBirth(params) {
    return `${params?.row?.dateOfBirth || "NA"}`;
  }

  function getQualification(params) {
    return `${params?.row?.qualification || "NA"}`;
  }

  function getSpecialization(params) {
    return `${params?.row?.specialization || "NA"}`;
  }

  function getCreatedAt(params) {
    const roleName = params?.row?.orwinCreatedAt;
    const a = moment(roleName).format("YYYY/MM/DD");

    return a;
  }
  function getUpdatedAt(params) {
    const roleName = params?.row?.orwinUpdatedAt;
    const a = moment(roleName).format("YYYY/MM/DD");

    return a;
  }

  function getOrwinCreatedAt(params) {
    const roleName = params?.row?.orwinCreatedAt;
    // const a = moment(roleName).format("YYYY/MM/DD");

    return roleName;
  }
  function getOrwinUpdatedAt(params) {
    const roleName = params?.row?.orwinUpdatedAt;
    // const a = moment(roleName).format("YYYY/MM/DD");

    return roleName;
  }
  function getCurrentCTC(params) {
    return `${params?.row?.currentCTC || "NA"}`;
  }

  function getExpectedCTC(params) {
    return `${params?.row?.expectedCTC || "NA"}`;
  }

  function getCity(params) {
    return `${params?.row?.city || "NA"}`;
  }

  function getState(params) {
    return `${params?.row?.state || "NA"}`;
  }

  function getPassingYear(params) {
    return `${params?.row?.passingYear || "NA"}`;
  }

  function getSkills(params) {
    return `${params?.row?.skills || "NA"}`;
  }

  function getProfileSummary(params) {
    return `${params?.row?.profileSummary || "NA"}`;
  }

  function getVideoResume(params) {
    return `${params?.row?.videoResume || "NA"}`;
  }

  function getLinkedInURL(params) {
    return `${params?.row?.linkedInURL || "NA"}`;
  }

  function getGitHubURL(params) {
    return `${params?.row?.gitHubURL || "NA"}`;
  }

  function getLanguagesKnown(params) {
    return `${params?.row?.languagesKnown || "NA"}`;
  }

  function getAreaOfferedFor(params) {
    return `${params?.row?.areaOfferedFor || "NA"}`;
  }

  function getDepartment(params) {
    return `${params?.row?.department || "NA"}`;
  }

  function getInactiveStartDate(params) {
    const roleName = params?.row?.inactiveStartDate;
    // const a = moment(roleName).format("YYYY/MM/DD");

    return roleName;
  }
  function getInactiveEndDate(params) {
    const roleName = params?.row?.inactiveEndDate;

    return roleName;
  }

  function getExperienceInMonths(params) {
    return `${params?.row?.experienceInMonths || "NA"}`;
  }

  function getEurrentEmployer(params) {
    return `${params?.row?.eurrentEmployer || "NA"}`;
  }

  function getJobType(params) {
    return `${params?.row?.jobType || "NA"}`;
  }

  function getLatestEmployer(params) {
    return `${params?.row?.computedLatestEmployer || "NA"}`;
  }

  function getIsEmailSubscribed(params) {
    return `${params?.row?.isEmailSubscribed || "NA"}`;
  }

  const columns = [
    {
      field: "ID",
      headerName: `ID`,
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?._id;
        return roleName;
      },
      valueGetter: getCandidateId,
    },
    {
      field: "code",
      headerName: `Candidate ID`,
      renderCell: (cellValues) => {
        const roleCode = cellValues?.row?.candidateId;
        // const rowCode = cellValues?.row?.code;
        // const rowId = cellValues?.row?._id;
        return roleCode;
        // return <Link to={`code/${rowCode}/${rowId}`}>{rowCode}</Link>;
      },
      //   flex: 1,
      valueGetter: getCandidateCode,
    },

    {
      field: "fullName",
      headerName: `Full Name`,
      renderCell: (cellValues) => {
        const rowCode = cellValues?.row?.fullName;
        return rowCode;
      },
      flex: 1,
      valueGetter: getFullName,
    },

    {
      field: "email",
      headerName: `Email`,
      renderCell: (cellValues) => {
        const rowName = cellValues?.row?.email;
        return rowName;
      },
      flex: 1,
      valueGetter: getEmail,
    },

    {
      field: "mobileNo",
      headerName: `Mobile Number`,
      renderCell: (cellValues) => {
        const rowName = cellValues?.row?.mobileNo;
        return rowName;
        // return (
        //   <Tooltip title={rowName} arrow>
        //     <div>{rowName}</div>
        //   </Tooltip>
        // );
      },
      //   flex: 1,
      valueGetter: getMobileNo,
    },

    {
      field: "alternateEmail",
      headerName: `Alternate Email`,
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.alternateEmail;
        return roleName;
      },
      //   flex: 1.5,
      valueGetter: getAlternateEmail,
    },

    {
      field: "dateOfBirth",
      headerName: "Date Of Birth",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.dateOfBirth;
        return roleName;
        // return (
        //   <Tooltip title={roleName} arrow>
        //     <div>{roleName}</div>
        //   </Tooltip>
        // );
      },
      //   flex: 1,
      valueGetter: getDateOfBirth,
    },

    {
      field: "qualification",
      headerName: "Qualification",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.qualification;

        return roleName;
      },
      //   flex: 1,
      valueGetter: getQualification,
    },
    {
      field: "specialization",
      headerName: "Specialization",
      renderCell: (cellValues) => {
        // console.log("1-->", cellValues)
        const roleName = cellValues?.row?.specialization;
        return roleName;
      },
      //   flex: 1,
      valueGetter: getSpecialization,
    },
    {
      field: "passingYear",
      headerName: "Passing Year",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.passingYear;
        return roleName;
      },
      //   flex: 1,
      valueGetter: getPassingYear,
    },
    {
      field: "currentCTC",
      headerName: "Current CTC",
      renderCell: (cellValues) => {
        // console.log("celllvalues>>>",cellValues)
        const roleName = cellValues?.row?.currentCTC;
        return roleName;
        // return (
        //   <Tooltip title={roleName} arrow>
        //     <div>{roleName}</div>
        //   </Tooltip>
        // );
      },
      //   flex: 1,
      valueGetter: getCurrentCTC,
    },
    {
      field: "expectedCTC",
      headerName: "Expected CTC",
      renderCell: (cellValues) => {
        // console.log("celllvalues>>>",cellValues)
        const rowName = cellValues?.row?.expectedCTC;
        // const rowName = rowName || "NA";
        return rowName;
        // return (
        //   <Tooltip title={rowName} arrow>
        //     <div>{rowName}</div>
        //   </Tooltip>
        // );
      },
      //   flex: 1,
      valueGetter: getExpectedCTC,
    },
    {
      field: "city",
      headerName: "City",
      renderCell: (cellValues) => {
        // const roleName = cellValues?.row?.ltcDateRange?.startDate;
        // return roleName;
        var a;
        const rowName = cellValues?.row?.city;
        return rowName;
      },
      //   flex: 1,
      valueGetter: getCity,
    },
    {
      field: "state",
      headerName: "State",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.state;
        return roleName;
      },
      //   flex: 1,
      valueGetter: getState,
    },
    {
      field: "skills",
      headerName: "Skills",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.skills;
        return roleName;
      },
      //   flex: 1,
      valueGetter: getSkills,
    },

    {
      field: "profileSummary",
      headerName: "Profile Summary",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.profileSummary;
        return roleName;
      },
      //   flex: 1,
      valueGetter: getProfileSummary,
    },

    {
      field: "videoResume",
      headerName: "Video Resume",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.videoResume;
        return roleName;
      },
      //   flex: 1,
      valueGetter: getVideoResume,
    },

    {
      field: "linkedInURL",
      headerName: "LinkedIn URL",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.linkedInURL;
        return roleName;
      },
      //   flex: 1,
      valueGetter: getLinkedInURL,
    },

    {
      field: "gitHubURL",
      headerName: "GitHub URL",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.gitHubURL;
        return roleName;
      },
      //   flex: 1,
      valueGetter: getGitHubURL,
    },

    {
      field: "languagesKnown",
      headerName: "Languages Known",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.languagesKnown;
        return roleName;
      },
      //   flex: 1,
      valueGetter: getLanguagesKnown,
    },

    {
      field: "areaOfferedFor",
      headerName: "Area Offered For",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.areaOfferedFor;
        return roleName;
      },
      //   flex: 1,
      valueGetter: getAreaOfferedFor,
    },

    {
      field: "department",
      headerName: "Department",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.department;
        return roleName;
      },
      //   flex: 1,
      valueGetter: getDepartment,
    },

    {
      field: "inactiveStartDate",
      headerName: "Inactive Start Date",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.inactiveStartDate;
        return roleName;
      },
      //   flex: 1,
      valueGetter: getInactiveStartDate,
    },

    {
      field: "inactiveEndDate",
      headerName: "Inactive End Date",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.inactiveEndDate;
        return roleName;
      },
      //   flex: 1,
      valueGetter: getInactiveEndDate,
    },

    {
      field: "experienceInMonths",
      headerName: "Experience In Months",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.experienceInMonths;
        return roleName;
      },
      //   flex: 1,
      valueGetter: getExperienceInMonths,
    },

    {
      field: "eurrentEmployer",
      headerName: "Current Employer",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.eurrentEmployer;
        return roleName;
      },
      //   flex: 1,
      valueGetter: getEurrentEmployer,
    },

    {
      field: "jobType",
      headerName: "Job Type",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.jobType;
        return roleName;
      },
      //   flex: 1,
      valueGetter: getJobType,
    },

    {
      field: "computedLatestEmployer",
      headerName: "Computed Latest Employer",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.computedLatestEmployer;
        return roleName;
      },
      //   flex: 1,
      valueGetter: getLatestEmployer,
    },

    {
      field: "isEmailSubscribed",
      headerName: "Is Email Subscribed",
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.isEmailSubscribed;
        return roleName;
      },
      //   flex: 1,
      valueGetter: getIsEmailSubscribed,
    },

    {
      field: "orwinCreatedAt",
      headerName: `Orwin Created At`,
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.orwinCreatedAt;
        // const a = moment(roleName).format("YYYY/MM/DD");

        return roleName;
      },
      type: "date",
      valueGetter: getOrwinCreatedAt,
    },
    {
      field: "orwinUpdatedAt",
      headerName: `Orwin Updated At`,
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.orwinUpdatedAt;

        // const a = moment(roleName).format("YYYY/MM/DD");

        return roleName;
      },
      type: "date",
      valueGetter: getOrwinUpdatedAt,
    },

    {
      field: "createdAt",
      headerName: `Created At`,
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.createdAt;
        const a = moment(roleName).format("YYYY/MM/DD");

        return a;
      },
      type: "date",
      valueGetter: getCreatedAt,
    },
    {
      field: "updatedAt",
      headerName: `Updated At`,
      renderCell: (cellValues) => {
        const roleName = cellValues?.row?.updatedAt;

        const a = moment(roleName).format("YYYY/MM/DD");

        return a;
      },
      type: "date",
      valueGetter: getUpdatedAt,
    },
  ];

  const [isOpen, setisOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const { Orwin_Candidate_Data } = useSelector((state) => state.user);
  // console.log("Orwin_Candidate_Data", Orwin_Candidate_Data);
  const softwares = Orwin_Candidate_Data?.Candidate_DataInfo;
  // console.log("softwares", softwares);

  const totalCount = Orwin_Candidate_Data?.total;
  const currentPage = useSelector((state) => state.user.currentPage);
  const pageSize = useSelector((state) => state.user.pageSize);
  const orwinSearchKey = useSelector((state) => state.user.orwinSearchKey);
  const orwinQualification = useSelector(
    (state) => state.user.orwinQualification
  );
  const orwinSpecialization = useSelector(
    (state) => state.user.orwinSpecialization
  );
  const orwinDepartment = useSelector((state) => state.user.orwinDepartment);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await dispatch(
        getOrwinCandidatesList({
          currentPage: currentPage,
          pageSize: pageSize,
          orwinSearchKey: orwinSearchKey,
          orwinQualification: orwinQualification,
          orwinSpecialization: orwinSpecialization,
          orwinDepartment: orwinDepartment,
        })
      );
      setLoading(false);
    };

    fetchData();
  }, [
    dispatch,
    currentPage,
    pageSize,
    orwinSearchKey,
    orwinQualification,
    orwinSpecialization,
    orwinDepartment,
  ]);

  var permanentLoading = Orwin_Candidate_Data?.Candidate_DataLoading;

  useEffect(() => {
    setLoading(permanentLoading);
  }, [permanentLoading]);

  useEffect(() => {
    if (state?.data) {
      setisOpen(true);
    }
  }, [state]);

  const handleDialogOpen = () => {
    setisOpen(true);
  };

  const handleDialogClose = () => {
    setisOpen(false);
  };

  // useEffect(() => {
  //   dispatch(getOrwinCandidatesList());
  // }, []);

  // console.log("251-->", softwares)

  function formatDate() {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const month = monthNames[now.getMonth()];
    const year = now.getFullYear();

    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    const formattedDate = `${day} ${month} ${year}_${hours}_${minutes}_${seconds}`;

    return formattedDate;
  }

   const handleResetFilters = () => {
     // Reset filter values to their initial state
     window.location.reload();
     setSelectedOption("");
     setManualValue("");
   };
  const handleSearch = () => {
      const sanitizedSearchKey = inputValue.replace(/[+#^&*()$]/g, "");
      // dispatch(searchKeyword(sanitizedSearchKey));
      if (sanitizedSearchKey) {
        dispatch(updateOrwinSearchKey(sanitizedSearchKey));
      }
    };
  
    const handleFilterSearch = () => {
      const qualificationSearchKey = inputQualificationValue
        .replace(/[+#^&*()$]/g, "")
        .trim();
      const specializationSearchKey = inputSpecializationFilterValue
        .replace(/[+#^&*()$]/g, "")
        .trim();
      const departmentSearchKey = inputDepartmentFilterValue
        .replace(/[+#^&*()$]/g, "")
        .trim();

      const sanitizedSearchKey = inputValue.replace(/[+#^&*()$]/g, "").trim();

      const filters = {};

      if (sanitizedSearchKey){
        filters.orwinSearchKey = sanitizedSearchKey;
      }
        if (qualificationSearchKey) {
          filters.orwinQualification = qualificationSearchKey;
        }

      if (specializationSearchKey) {
        filters.orwinSpecialization = specializationSearchKey;
      }

      if (departmentSearchKey) {
        filters.orwinDepartment = departmentSearchKey;
      }

      // Call API with all active (non-empty) filters
      dispatch(getOrwinCandidatesList(filters));
    };


    // console.log("inputValue>>", inputValue)
  
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        // handleSearch();
        handleFilterSearch();
      }
    };

     return (
       <>
         {" "}
         <DashboardLayout>
           {" "}
           <DashboardNavbar />{" "}
           <div style={{ display: "flex", alignItems: "center" }}>
             <FilterBar
               title1="Orwin Candidates"
               isOpen={isOpen}
               handleDialogOpen={handleDialogOpen}
               handleDialogClose={handleDialogClose}
               showisDeleted={false}
               showDialog={false}
             />
             <Button
               onClick={handleResetFilters}
               color="primary"
               style={{
                 marginLeft: "20px", // Adjust as needed
                 marginTop: "20px",
                 // width: "130px",
                 // height: "5px",
                 padding: "5px 10px",
                 // lineHeight: "-5",
               }}
               variant="contained"
               startIcon={<RefreshIcon style={{ fontSize: 50 }} />}
             >
               Reset All
             </Button>
           </div>
           <Select
             value={selectedOption}
             onChange={(e) => setSelectedOption(e.target.value)}
             displayEmpty
             renderValue={(selected) => {
               if (!selected) {
                 return (
                   <span style={{ paddingRight: "20px" }}>Choose Filters</span>
                 );
               }
               return selected.charAt(0).toUpperCase() + selected.slice(1);
             }}
             style={{ marginLeft: "20px", height: "44px", minWidth: "120px" }}
           >
             <MenuItem value="">Choose Filters</MenuItem>
             <MenuItem value="qualification">Qualification</MenuItem>
             <MenuItem value="specialization">Specialization</MenuItem>
             <MenuItem value="department">Department</MenuItem>
           </Select>
           {selectedOption && (
             <>
               {selectedOption === "qualification" ? (
                 <FormControl
                   fullWidth
                   style={{
                     marginLeft: "20px",
                     width: "100px",
                     height: "44px",
                   }}
                 >
                   {/* <InputLabel
                     id="role-select-label"
                     style={{ textAlign: "center" }}
                   >
                     Select Qualification
                   </InputLabel> */}
                   <TextField
                     label={`Search by Qualification`}
                     value={inputQualificationValue}
                     onChange={(e) =>
                       setInputQualificationFilterValue(e.target.value || "")
                     }
                     onKeyPress={handleKeyPress}
                     style={{
                       marginLeft: "80px",
                       //  position: "absolute",
                       right: "80px",
                       width: "190px",
                     }}
                   />
                 </FormControl>
               ) : selectedOption === "specialization" ? (
                 <FormControl
                   fullWidth
                   style={{
                     marginLeft: "20px",
                     width: "100px",
                     height: "44px",
                   }}
                 >
                   {/* <InputLabel
                     id="role-select-label"
                     style={{ textAlign: "center" }}
                   >
                     Select Specialization
                   </InputLabel> */}
                   <TextField
                     label={`Search by Specialization`}
                     value={inputSpecializationFilterValue}
                     onChange={(e) =>
                       setInputSpecializationFilterValue(e.target.value)
                     }
                     onKeyPress={handleKeyPress}
                     style={{
                       //  position: "absolute",
                       marginLeft: "80px",
                       right: "80px",
                       width: "190px",
                     }}
                   />
                 </FormControl>
               ) : selectedOption === "department" ? (
                 <FormControl
                   fullWidth
                   style={{
                     marginLeft: "20px",
                     width: "100px",
                     height: "44px",
                   }}
                 >
                   {/* <InputLabel
                     id="role-select-label"
                     style={{ textAlign: "center" }}
                   >
                     Select Department
                   </InputLabel> */}
                   <TextField
                     label={`Search by Department`}
                     value={inputDepartmentFilterValue}
                     onChange={(e) =>
                       setInputDepartmentFilterValue(e.target.value)
                     }
                     onKeyPress={handleKeyPress}
                     style={{
                       //  position: "absolute",
                       marginLeft: "80px",
                       right: "80px",
                       width: "190px",
                     }}
                   />
                 </FormControl>
               ) : null}
             </>
           )}
           <TextField
             label={`Search by profName,number`}
             value={inputValue}
             onChange={(e) => setInputValue(e.target.value)}
             onKeyPress={handleKeyPress}
             style={{ position: "absolute", right: "80px", width: "190px" }}
           />
           <Button
             variant="contained"
             color="primary"
             onClick={() => {
               //  handleSearch();
               handleFilterSearch();
             }}
             style={{
               position: "absolute",
               right: "10px",
               width: "50px",
               height: "44px",
             }}
           >
             Search
           </Button>
           <MDBox sx={{ marginTop: "1rem" }}>
             {" "}
             <DataGrid
               density="compact"
               getRowId={(row) => row?._id}
               components={{ Toolbar: GridToolbar }}
               initialState={{
                 columns: {
                   columnVisibilityModel: {
                     // _id: true,
                     ID: false,
                     candidateId: true,
                     fullName: true,
                     email: true,
                     mobileNo: true,
                     alternateEmail: false,
                     dateOfBirth: false,
                     qualification: true,
                     specialization: true,
                     passingYear: false,
                     currentCTC: false,
                     expectedCTC: false,
                     city: true,
                     state: true,
                     country: false,
                     willingToRelocate: false,
                     shift: false,
                     PAN_Number: false,
                     Passport_Number: false,
                     nursingCouncil: false,
                     registrationState: false,
                     source: true,
                     owner: true,
                     orwinCreatedBy: true,
                     orwinCreatedAt: false,
                     orwinUpdatedAt: false,
                     skills: false,
                     softSkills: false,
                     profileSummary: false,
                     videoResume: false,
                     linkedInURL: false,
                     gitHubURL: false,
                     languagesKnown: false,
                     areaOfferedFor: false,
                     department: true,
                     inactiveStartDate: false,
                     inactiveEndDate: false,
                     experienceInMonths: true,
                     eurrentEmployer: false,
                     jobType: false,
                     computedLatestEmployer: false,
                     isEmailSubscribed: true,
                     createdAt: true,
                     updatedAt: true,
                   },
                 },
               }}
               componentsProps={{
                 toolbar: {
                   // showQuickFilter: true,
                   csvOptions: { disableToolbarButton: true },
                   quickFilterProps: { debounceMs: 500 },
                   printOptions: { disableToolbarButton: true },
                 },
               }}
               slots={{
                 loadingOverlay: <CircularProgress disableShrink />,
               }}
               loading={loading && <CircularProgress />}
               columns={columns}
               rows={softwares?.length > 0 ? [...softwares] : []}
               pageSize={pageSize}
               rowCount={totalCount}
               paginationMode="server"
               pagination
               page={currentPage}
               onPageSizeChange={(newPageSize) =>
                 dispatch(pageLimit(newPageSize))
               }
               onPageChange={(newPage) => dispatch(pageChanged(newPage))}
               rowsPerPageOptions={[10, 25, 50, 100]}
               sx={{
                 backgroundColor: "#ffff",
                 color: "grey",
                 height: "35rem",
                 margin: "1rem",
                 borderRadius: "0.5rem",
                 "& .MuiDataGrid-cell": {
                   padding: "15px",
                   fontSize: "12px",
                 },
                 borderColor: "light-grey",
                 "& .MuiDataGrid-cell:hover": {
                   color: "info",
                 },
               }}
               disableColumnFilter
             />{" "}
           </MDBox>{" "}
         </DashboardLayout>{" "}
       </>
     );
  // return (
  //   <DashboardLayout className="dashboardLayout">
  //     <DashboardNavbar />
  //     <FilterBar
  //       // title="Create Job"
  //       title1="Orwin Candidates"
  //       isOpen={isOpen}
  //       handleDialogOpen={handleDialogOpen}
  //       handleDialogClose={handleDialogClose}
  //       showisDeleted={false}
  //       showDialog={false}
  //     />
  //     <TextField
  //       label={`Search by profName,number`}
  //       value={inputValue}
  //       onChange={(e) => setInputValue(e.target.value)}
  //       onKeyPress={handleKeyPress}
  //       style={{ position: "absolute", right: "80px", width: "190px" }}
  //     />
  //     <DataGrid
  //       getRowId={(row) => row._id}
  //       components={{ Toolbar: GridToolbar }}
  //       componentsProps={{
  //         toolbar: {
  //           showQuickFilter: true,
  //           quickFilterProps: { debounceMs: 500 },
  //           printOptions: { disableToolbarButton: true },
  //           csvOptions: {
  //             fileName: `OrwinCandidates-${formatDate()}`,
  //           },
  //         },
  //       }}
  //       density="compact"
  //       initialState={{
  //         columns: {
  //           columnVisibilityModel: {
  //             // _id: true,
  //             ID: false,
  //             candidateId: true,
  //             fullName: true,
  //             email: true,
  //             mobileNo: true,
  //             alternateEmail: false,
  //             dateOfBirth: false,
  //             qualification: true,
  //             specialization: true,
  //             passingYear: false,
  //             currentCTC: false,
  //             expectedCTC: false,
  //             city: true,
  //             state: true,
  //             country: false,
  //             willingToRelocate: false,
  //             shift: false,
  //             PAN_Number: false,
  //             Passport_Number: false,
  //             nursingCouncil: false,
  //             registrationState: false,
  //             source: true,
  //             owner: true,
  //             orwinCreatedBy: true,
  //             orwinCreatedAt: false,
  //             orwinUpdatedAt: false,
  //             skills: false,
  //             softSkills: false,
  //             profileSummary: false,
  //             videoResume: false,
  //             linkedInURL: false,
  //             gitHubURL: false,
  //             languagesKnown: true,
  //             areaOfferedFor: false,
  //             department: true,
  //             inactiveStartDate: false,
  //             inactiveEndDate: false,
  //             experienceInMonths: true,
  //             eurrentEmployer: false,
  //             jobType: true,
  //             computedLatestEmployer: false,
  //             isEmailSubscribed: true,
  //             createdAt: true,
  //             updatedAt: true,
  //           },
  //         },
  //       }}
  //       // isRowSelectable
  //       // loading={permanentLoading ? true : false}
  //       loading={loading && <CircularProgress />}
  //       columns={columns}
  //       rows={softwares?.length > 0 ? [...softwares] : []}
  //       pageSize={pageSize}
  //       rowCount={totalCount}
  //       paginationMode="server"
  //       pagination
  //       page={currentPage}
  //       onPageSizeChange={(newPageSize) => dispatch(pageLimit(newPageSize))}
  //       onPageChange={(newPage) => dispatch(pageChanged(newPage))}
  //       rowsPerPageOptions={[10, 25, 50, 100]}
  //       // rows={[...softwares]}
  //       // pagination
  //       // pageSize={100}
  //       // rowsPerPageOptions={[100]}
  //       sx={{
  //         backgroundColor: "#ffff",
  //         color: "grey",
  //         height: "35rem",
  //         margin: "1rem",
  //         borderRadius: "0.5rem",
  //         "& .MuiDataGrid-cell": {
  //           padding: "15px",
  //           fontSize: "12px",
  //         },
  //         borderColor: "light-grey",
  //         "& .MuiDataGrid-cell:hover": {
  //           color: "info",
  //         },
  //       }}
  //       disableColumnFilter
  //     />
  //   </DashboardLayout>
  // );
}

export default OrwinCandidates;
